module.exports = __webpack_public_path__ + "img/deco_trees.4fa98718.png";